import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ActionsProvider } from "./components/ActionDialogs";
import { ChangePasswordDialog } from "./components/ChangePasswordDialog";
import { Layout } from "./components/Layout";
import { BRAND } from "./config/brand";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Clients from "./pages/Clients";
import ClientDetail from "./pages/ClientDetail";
import Payments from "./pages/Payments";
import Expenses from "./pages/Expenses";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";

function FullScreenLoader() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3">
      <img src={BRAND.logos.symbol} alt={BRAND.name} className="h-14 w-14 object-contain animate-pulse" />
      <p className="text-slate-400 text-sm">Yükleniyor…</p>
    </div>
  );
}

function Protected() {
  const { user, setUser } = useAuth();
  if (user === null) return <FullScreenLoader />;
  if (user === false) return <Navigate to="/login" replace />;
  return (
    <Layout>
      <Outlet />
      <ChangePasswordDialog open={!!user.must_change_password} forced
        onDone={() => setUser({ ...user, must_change_password: false })} />
    </Layout>
  );
}

function LoginRoute() {
  const { user } = useAuth();
  if (user === null) return <FullScreenLoader />;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ActionsProvider>
            <Routes>
              <Route path="/login" element={<LoginRoute />} />
              <Route element={<Protected />}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/muvekkiller" element={<Clients />} />
                <Route path="/muvekkiller/:id" element={<ClientDetail />} />
                <Route path="/odemeler" element={<Payments />} />
                <Route path="/masraflar" element={<Expenses />} />
                <Route path="/raporlar" element={<Reports />} />
                <Route path="/ayarlar" element={<Settings />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </ActionsProvider>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
